import * as prismic from '@prismicio/client'
import { Observable, of } from 'rxjs'
import { startWith, catchError } from 'rxjs/operators'
import { RESPONSE_NOTFOUND, RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { DEFAULT_CACHE_TTL } from 'libraries/front-end-core/constants/request'
import debug from 'libraries/front-end-core/core/debug'

export const buildPrismicContext = ({ endpoint }) => {
  try {
    // Never let the browser serve a cached response - a page refresh should always hit the network.
    const client = prismic.createClient(endpoint, { fetchOptions: { cache: 'no-store' } })
    return ({ endpoint, api: client })
  } catch (error) {
    throw new Error(`[Prismic Client Error] ${error}`)
  }
}

const initCache = () => {
  const store = new Map()
  return ({ request, ctx, props, cacheKey, cacheTtl = DEFAULT_CACHE_TTL }) => {
    return new Observable(observer => {
      const cached = store.get(cacheKey)
      const isStale = !cached || cacheTtl === 0 || (Date.now() - cached.timestamp > cacheTtl)

      if (!isStale) {
        // Check if the same request has been made before, and is still fresh.
        observer.next(cached.result)
      } else {
        // Request object from API.
        return request(ctx, props).then(result => {
          if (result) {
            store.set(cacheKey, { result, timestamp: Date.now() })
            observer.next(result)
          } else {
            observer.next(RESPONSE_NOTFOUND)
          }
        }).catch(error => {
          debug.warn(`[CMS Request Error] ${error.message}`)
          observer.next(RESPONSE_NOTFOUND)
        })
      }
    }).pipe(
      startWith(RESPONSE_PENDING),
      catchError((e) => {
        debug.warn(`[CMS Request Error] ${e.message}`)
        return of(RESPONSE_NOTFOUND)
      }))
  }
}

export const cache = initCache()
